export default function mapDocSnapshot(snapshot) {
    if (snapshot.exists()) {
        const data = { ...snapshot.data(), id: snapshot.id };
        return data;
    } else {
        return null;
    }
}
